import { createContext, useContext } from 'react';

export interface SearchEvents {
  [key: string]: number;
}

export const SearchEventsContext = createContext({} as SearchEvents);

export function useSearchEventsContext() {
  return useContext(SearchEventsContext);
}
